import React from 'react'
import PropTypes from 'prop-types'
import { Translation } from 'react-i18next'
import { I18nInternalContext } from './internal/I18nInternalContext'

/**
 * 所有业务页面的 i18n 展示，使用 FormattedMessage 实现
 * 解决语言包加载的中间态，页面使用 missingKey 渲染的问题。直接输出 '' 将导致抖动
 * 同时，解决业务手动调用 t() 的问题，从命令式代码变为声明式
 */
export class FormattedMessage extends React.PureComponent {
  static contextType = I18nInternalContext

  renderContent(t) {
    const { props } = this
    const content = t(props.keys, props.options)
    const isMissingKey = this.context
      ? this.context.isI18nResourceLoading && content === ''
      : content === ''
    return (
      <span
        className={props.className}
        style={props.style}
        // 展示为占位高度的特殊空格
        {...(isMissingKey
          ? { dangerouslySetInnerHTML: { __html: '&emsp;&emsp;' } }
          : null)}
      >
        {isMissingKey ? null : content}
      </span>
    )
  }

  render() {
    const namespace =
      this.props.namespaces ||
      (this.context ? this.context.namespace : undefined)
    // 跨组件时，默认未从父级获取 namespace，导致部分场景下无法正确计算
    return (
      <Translation ns={namespace}>{(t) => this.renderContent(t)}</Translation>
    )
  }
}

FormattedMessage.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  namespaces: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.string.isRequired),
  ]),
  // 与 t(keys, options) 定义一致
  keys: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.string.isRequired),
  ]).isRequired,
  options: PropTypes.any,
}
